export const gallery = {
  title: "ギャラリー",
  tabMovie: "動画",
  tabImage: "画像",
  empty: "購入済みのアイテムはありません",
  emptyFavorites: "お気に入りに登録したアイテムはありません",
  emptyUnopened: "未開封のアイテムはありません",
  favorite: "お気に入りに追加",
  unfavorite: "お気に入りを解除",
  favoritesOnly: "お気に入りのみ",
  statusUnopened: "未開封",
  statusOpened: "開封済み",
  cardAlt: (args: { name: string | number }) =>
    `${args.name} の購入済みコンテンツ`,
  imageAlt: (args: { name: string | number }) => `${args.name} の画像`,
  openProfile: (args: { name: string | number }) =>
    `${args.name}さんのプロフィールを開く`,
} as const;
